import { render, staticRenderFns } from "./uni-popup-message.vue?vue&type=template&id=19d2db83"
import script from "./uni-popup-message.vue?vue&type=script&lang=js"
export * from "./uni-popup-message.vue?vue&type=script&lang=js"
import style0 from "./uni-popup-message.vue?vue&type=style&index=0&id=19d2db83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports